/**
 * MOCK · CANONICAL (CT-5525) — what the create form offers.
 *
 * Locations, industries and cities are tenant data, so they travel as options
 * rather than living as constants in a component. Owners are people of the
 * tenant; the endpoint searches and pages them on the server.
 */

const option = (label) => ({ value: label, label });

export const MOCK_LOCATIONS = [
  'Chicago, IL',
  'Detroit, MI',
  'Austin, TX',
  'New York, NY',
  'San Francisco, CA',
  'Remote — US',
].map(option);

export const MOCK_INDUSTRIES = [
  'Automotive Retail',
  'Healthcare',
  'Enterprise Software',
  'Logistics',
  'Manufacturing',
  'Financial Services',
].map(option);

export const MOCK_CITIES = ['Chicago', 'Detroit', 'Austin', 'New York', 'San Francisco', 'Boston'].map(option);

export const MOCK_OWNERS = [
  { user_uuid: 'u-priya', name: 'Priya Nair', email: 'priya.nair@aimsos.ai' },
  { user_uuid: 'u-daniel', name: 'Daniel Ruiz', email: 'daniel.ruiz@aimsos.ai' },
  { user_uuid: 'u-marcus', name: 'Marcus Webb', email: 'marcus.webb@aimsos.ai' },
  { user_uuid: 'u-elena', name: 'Elena Fischer', email: 'elena.fischer@aimsos.ai' },
  { user_uuid: 'u-sam', name: 'Sam Ortiz', email: 'sam.ortiz@aimsos.ai' },
  { user_uuid: 'u-dana', name: 'Dana Ruiz', email: 'dana.ruiz@aimsos.ai' },
];
